// This is a custom section renderer, which is specific to CommsPlanSectionTypes.TEXT and renderd a text field with
// a unique name which allows the server to determine what updates to make when saving
import React, {Fragment} from "react";
import ReactHookFormError from "./ReactHookFormError";
import FormToggle from "root/ReactHookForm/ControlWrappers/FomToggle";
import DropdownPeriodicity from "root/ReactHookForm/ControlWrappers/DropdownPeriodicity";

import './FormItemMediaExchange.scss';
import {useWatch} from "react-hook-form";

const FormItemMediaExchange = ({heading, name, item, objectName, formSectionName, control, register, watch, formErrors}) =>
{
    const sliderGroupStyle = {
        display: 'grid',
        gridTemplateColumns: '4fr 1fr',
        marginTop: '15px',
        fontSize: 'larger'
    }

    if ( heading === 'Letters may include Photographs')
    {
        console.log ( item ) ;
    }

    const elementName = formSectionName === undefined ? name : formSectionName + '.media.' + name + '#toggle';
    const periodicityName = formSectionName === undefined ? name : formSectionName + '.media.' + name + '#periodicity_id';
    const allowedCountName = formSectionName === undefined ? name : formSectionName + '.media.' + name + '#max_allowed_count';

    const toggleValue = useWatch({ control: control, name: elementName }) ;

    if ( heading === 'Letters may include Photographs')
    {
        console.log ( elementName ) ;
        console.log ( toggleValue ) ;
    }

    const dropDownValidation = ( val ) =>
    {
        if ( toggleValue === true)
        {
            if ( val === null )
            {
                return "You must select a periodicity" ;
            }
        }
    }

    return (
        <Fragment key={name}>
            <div className='media-layout'>
                <div>
                    <label style={{fontSize: 'normal'}}>{heading}</label>
                    <div style={{justifySelf: 'right'}}>
                        <FormToggle readOnly={false} control={control} name={elementName}/>
                        <ReactHookFormError formErrors={formErrors} name={name + '#toggle'} path='contact' subPath='media'/>
                    </div>
                </div>
                <div>
                    <label>Periodicity</label>
                    <DropdownPeriodicity readOnly={!toggleValue} name={periodicityName} rules={{validate:dropDownValidation}} control={control}/>
                    <ReactHookFormError formErrors={formErrors} name={name + '#periodicity_id'} path='contact' subPath='media'/>
                </div>
                <div>
                    {heading !== null && <label>Max allowed in period</label>}
                    <input className='form-control' readOnly={!toggleValue} {...register(allowedCountName, {
                        required: toggleValue,
                        maxLength: 3
                    })} />
                    <ReactHookFormError formErrors={formErrors} name={name + '#max_allowed_count'} path='contact' subPath='media'/>
                </div>
            </div>
        </Fragment>
    )
}

export default FormItemMediaExchange;
